<script lang="ts">
  import Layout from "$app/Layouts/Plan.svelte"
  import PlanCertification from "./PlanCertification.svelte"

  let props = $props()
  let plan_certifications: any = props.plan_certifications
  let user_certifications: any = props.user_certifications || []
  let user: any = props.user
</script>

<Layout {...props}>
  <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
    <section class="max-w-3xl mx-auto lg:max-w-7xl">
      <div class="py-8 lg:py-12">
        <h2
          class="text-center text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
        >
          Your Certifications
        </h2>
      </div>
    </section>

    <section class="mx-auto md:max-w-3xl lg:max-w-4xl px-3 lg:px-0">
      <h3 class="text-2xl md:text-3xl font-semibold text-lwp-theme-blue">
        Your Plan Certifications
      </h3>
      <div class="flex flex-col mt-8">
        {#if plan_certifications.length === 0}
          <div class="border-l-4 border-blue-400 bg-blue-50 p-4">
            <div class="flex">
              <div class="flex-shrink-0">
                <svg
                  class="h-5 w-5 text-blue-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div class="ml-3">
                <p class="text-sm text-blue-700">
                  None of your plans have any certifications.
                </p>
              </div>
            </div>
          </div>
        {/if}
        <ul class="gap-y-4 w-full">
          {#each plan_certifications as certification}
            <PlanCertification {certification} {user} />
          {/each}
        </ul>
      </div>
    </section>
  </div>
</Layout>
